<template lang="pug">
v-dialog(data-cy="pagination-list-modal.dialog" :value="value" persistent width='800px')
  v-card
    title-bar(data-cy="pagination-list-modal.title" dark) {{ `${title}: ${total}` }}
    v-flex.pa-4.flex
      span(data-cy="pagination-list-modal.description" xs12) {{ description }}
      div.column-wrapper(xs12)
        div(v-for='item in items' :key="item.id" :style="widthStyle").column
          slot(name='items' :item="item")
      v-layout.pagination(xs12)
        v-flex.limits
          pagination-limit.mr-4(
            :limits="paginationLimits"
            :current-limit="limit"
            @change:limit="setPageLimit"
            )
        v-flex.pages
          v-pagination(
            :value="getPage"
            :length="pageCount"
            @input="setPage"
            :total-visible="7"
            v-show="pageCount > 1"
          )
    v-card-actions
      v-spacer
      v-btn(data-cy="pagination-list-modal.description.close" flat @click="closeDialog") Close
</template>
    
<script>
import TitleBar from '@/Core/components/TitleBar';
import PaginationLimit from '@/Core/components/PaginationLimit';

export default {
  components: {
    TitleBar,
    PaginationLimit,
  },
  data() {
    return {
      paginationLimits: [15, 30, 45, 60],
    };
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
    },
    total: {
      type: Number,
    },
    skip: {
      type: Number,
    },
    limit: {
      type: Number,
    },
    columns: {
      type: Number,
      default: 3,
    }
  },

  computed: {
    getPage() {
      return Math.floor(this.skip / this.limit) + 1;
    },
    pageCount() {
      return Math.ceil(this.total / this.limit) || 0;
    },
    widthStyle() {
      if (this.columns === 0) {
        return {};
      }
      const widthPercentage = 100 / this.columns;
      return { 'width': `${widthPercentage}%` };
    }
  },

  methods: {
    setPage(page) {
      this.$emit('setPage', page);
    },
    setPageLimit(limit) {
      this.$emit('setPageLimit', limit);
    },
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>
    
<style lang="scss" scoped>
.column-wrapper {
  max-height: 33vh;
  padding-top: 12px;
  display: flex;
  flex-wrap: wrap;
  overflow-y: auto;
}

.column {
  padding: 3px;
}

.pagination {
  height: 60px;
}
</style>
